<div class="pb-2">
  <kendo-combobox [class.k-state-invalid]="showError" [formControl]="formControl"
    [formlyAttributes]="field" [class]="to.className"
    [data]="usesCodeSet ? dictionaryData : (to.options | formlySelectOptions:field | async)"
    [textField]="textField" [valueField]="valueField"
    (valueChange)="to.change && to.change(field, $event)" [valuePrimitive]="true">
  </kendo-combobox>
  <small *ngIf="to.description" class="form-text text-muted">{{ to.description }}</small>
</div>
